import { SmartTable } from '../../../../../../components/smart-table/smart-table.model';

export class Controller {

	/** @ngInject */
	constructor(
		$state,
		CompanyUser,
		ConfirmDeleteModal,
		SharedFoldersResource,
		Alert
	) {
		this.$state = $state;
		this.CompanyUser = CompanyUser;
		this.ConfirmDeleteModal = ConfirmDeleteModal;
		this.SharedFoldersResource =  SharedFoldersResource;
		this.Alert = Alert;
	}

	$onInit() {
		this.selectedLabels = this.sharedLabels.filter((item) => item.isShared);
		this.$sharedLabels =  JSON.parse(JSON.stringify(this.sharedLabels));
        this.newUserIdentifier = null;
        this.userIdentifier = null;
        this.st = new SmartTable();
        this.stLabels = new SmartTable();
	}

	identifyUser() {
		this.message = null;
		this.userIdentifier = this.newUserIdentifier;

		this.CompanyUser.identifyCompanyUser({
			companyId: this.companyId,
			uid: encodeURIComponent(this.userIdentifier)
		}).$promise
			.then((response) => {

				this.successResult = true;
				this.showVerification = false;
				this.companyUser = response;
				this.message = 'groups_users.user_found';
			})
			.catch((error) => {
				this.successResult = false;
				this.companyUser = null;

				this.showVerification = this.enableVerification && !this.successResult
					&& $rootScope.emailPattern.test(this.userIdentifier);

				if (error.status == 404) {
					this.message = 'groups_users.user_not_found';
				} else {
					this.message = response.data.message;
				}
			})

	}

	getSharingTypeDisplayName(sharingType) {
        if (sharingType == 'INDIVIDUAL_AND_TEAM') {
            return 'INDIVIDUAL & TEAM';
        } else {
            return sharingType;
        }
    }

	share(saaspassId) {
		this.SharedFoldersResource.shareWithSaaspassId(this.companyId, this.sharedFolderId, saaspassId)
		.then((response) => {
			this.successMessageAndReload('global.messages.operation-successful');
		})
	}

	unshare(saaspassId) {
		this.saaspassId = saaspassId;
		this.ConfirmDeleteModal('company.sharing-center.shared-folders.confirm-unshare')
			.then(() => {
				this.SharedFoldersResource.unshareWithSaaspassId(this.companyId, this.sharedFolderId, saaspassId)
				.then((response) => {
					this.successMessageAndReload('global.messages.operation-successful');
				})
			});
	}

	cancelSearch() {
		this.userIdentifier = null;
		this.successResult = null;
		this.showVerification = false;
		this.companyUser = null;
		this.message = null;
		this.newUserIdentifier = null;
	}
	
	clickLabel(label) {
		if (label.name === "ALL_USERS") {
			this.sharedLabels.map((item) => {
				if (item.name !== "ALL_USERS") {
					item.isShared = false;
				}
			});
		}
		this.selectedLabels = this.sharedLabels.filter((item) => item.isShared);
	}

	isCheckboxDisabled(label) {
		var isIt = (label.name !== "ALL_USERS") && (this.selectedLabels.length==1) && (this.selectedLabels[0].name==="ALL_USERS");
		return isIt;
	}

	sharedLabelsNotModified() {
		return angular.equals(this.$sharedLabels, this.sharedLabels);
	}
	
	shareWithLabels(){
		this.SharedFoldersResource.updateSharedLabels(this.companyId, this.sharedFolderId, this.sharedLabels)
		.then((response) => {
			this.successMessageAndReload('global.messages.operation-successful');
		});
	}
	
	successMessageAndReload(key) {
		this.$state.go('.', {}, {reload: '.'});
		this.Alert('success', key);
	}
}


// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-folders/manage/share/share-shared-folder.controller.js